import './components/swiper';
// import './components/compote';
// import "./components/tomselect";
import './components/photoswipe';
import './components/modal';
import './components/tab';
// import "./components/tooltip";
import './components/accordeon';
import './components/modal-video';

import './global/init';
import './global/navigation';
